import { lazyRouteComponent, Outlet } from '@tanstack/react-router';
import DocumentEditorPage from 'src/modules/editors/document-editor/pages/DocumentEditorPage/DocumentEditorPage';
import PalletTagEditorPage from 'src/modules/editors/pallet-tags-editor/pages/PalletTagEditorPage/PalletTagEditorPage';
import AgrifulFrame from 'src/modules/pageFrame/AgrifulFrame';
import AccountingSettingsPage from 'src/modules/settings/accounting/AccountingSettingsPage';
import BusinessSetupPage from 'src/modules/settings/business/BusinessSettingsPage';
import DocumentSettingsPage from 'src/modules/settings/documents/DocumentSettingsPage';
import EmailSettingsPage from 'src/modules/settings/emails/EmailSettingsPage';
import InventorySettingsPage from 'src/modules/settings/inventory/InventorySettingsPage';
import WarehouseDetailsPage from 'src/modules/settings/inventory/warehouses/WarehouseDetailsPage';
import OrderSettingsPage from 'src/modules/settings/orders/OrderSettingsPage';
import SettingsPage from 'src/modules/settings/SettingsPage';
import TeamSettingsPage from 'src/modules/settings/team/TeamSettingsPage';
import { ChatRouteHost } from './ChatRouteHost';

export {
  AccountingSettingsPage,
  BusinessSetupPage,
  DocumentEditorPage,
  DocumentSettingsPage,
  EmailSettingsPage,
  InventorySettingsPage,
  OrderSettingsPage,
  PalletTagEditorPage,
  SettingsPage,
  TeamSettingsPage,
  WarehouseDetailsPage,
};

export function AgrifulLayout() {
  return (
    <AgrifulFrame>
      <ChatRouteHost>
        <Outlet />
      </ChatRouteHost>
    </AgrifulFrame>
  );
}

export function EmptyPage() {
  return null;
}

// Keep page split points explicit in the code-based tree so route modules remain lazy-loaded.
export const AccountRegisterPage = lazyRouteComponent(
  () => import('src/pages/AccountRegisterPage/AccountRegisterPage')
);
export const AccountingReportsPage = lazyRouteComponent(
  () => import('src/pages/AccountingReportsPage/AccountingReportsPage')
);
export const AccountsPage = lazyRouteComponent(() => import('src/pages/AccountsPage/AccountsPage'));
export const AgingReportsPage = lazyRouteComponent(() => import('src/pages/AgingReportsPage/AgingReportsPage'));
export const AiInboxPage = lazyRouteComponent(() => import('src/pages/AiInboxPage/AiInboxPage'));
export const BIDashboardsPage = lazyRouteComponent(() => import('src/pages/BIDashboardsPage/BIDashboardsPage'));
export const BillPage = lazyRouteComponent(() => import('src/pages/BillPage/BillPage'));
export const BusinessIntelligencePage = lazyRouteComponent(
  () => import('src/pages/BusinessIntelligencePage/BusinessIntelligencePage')
);
export const BuySellOrderPage = lazyRouteComponent(() => import('src/pages/BuySellOrderPage/BuySellOrderPage'));
export const DocumentOnboardingPage = lazyRouteComponent(
  () => import('src/pages/DocumentOnboardingPage/DocumentOnboardingPage')
);
export const ReceivingTicketPage = lazyRouteComponent(
  () => import('src/pages/ReceivingTicketPage/ReceivingTicketPage')
);
export const GrowerProductPage = lazyRouteComponent(() => import('src/pages/GrowerProductPage/GrowerProductPage'));
export const GrowerProductsPage = lazyRouteComponent(() => import('src/pages/GrowerProductsPage/GrowerProductsPage'));
export const InventoryPage = lazyRouteComponent(() => import('src/pages/InventoryPage/InventoryPage'));
export const InventoryTransferPage = lazyRouteComponent(
  () => import('src/pages/InventoryTransferPage/InventoryTransferPage')
);
export const InventoryTransfersPage = lazyRouteComponent(
  () => import('src/pages/InventoryTransfersPage/InventoryTransfersPage')
);
export const LandingPage = lazyRouteComponent(() => import('src/pages/LandingPage/LandingPage'));
export const LoginPage = lazyRouteComponent(() => import('src/pages/LoginPage/LoginPage'));
export const NotAMemberPage = lazyRouteComponent(() => import('src/pages/NotAMemberPage/NotAMemberPage'));
export const NotFoundPage = lazyRouteComponent(() => import('src/pages/NotFoundPage/NotFoundPage'));
export const OrderBoardPage = lazyRouteComponent(() => import('src/pages/OrderBoardPage/OrderBoardPage'));
export const PalletTagsPage = lazyRouteComponent(() => import('src/pages/PalletTagsPage/PalletTagsPage'));
export const PaymentPage = lazyRouteComponent(() => import('src/pages/PaymentPage/PaymentPage'));
export const PaymentsPage = lazyRouteComponent(() => import('src/pages/PaymentsPage/PaymentsPage'));
export const PricingSheetPage = lazyRouteComponent(() => import('src/pages/PricingSheetPage/PricingSheetPage'));
export const PrintChecksPage = lazyRouteComponent(() => import('src/pages/PrintChecksPage/PrintChecksPage'));
export const RecipeBuilderPage = lazyRouteComponent(() => import('src/pages/RecipeBuilderPage/RecipeBuilderPage'));
export const ScanDebugPage = lazyRouteComponent(() => import('src/pages/ScanDebugPage/ScanDebugPage'));
export const ScanLocationPage = lazyRouteComponent(() => import('src/pages/ScanLocationPage/ScanLocationPage'));
export const ScanPage = lazyRouteComponent(() => import('src/pages/ScanPage/ScanPage'));
export const UserProfilePage = lazyRouteComponent(() => import('src/pages/UserProfilePage/UserProfilePage'));
export const ViewInvoicesPage = lazyRouteComponent(() => import('src/pages/ViewInvoicesPage/ViewInvoicesPage'));
export const LotPage = lazyRouteComponent(() => import('src/pages/LotPage/LotPage'));
export const ViewPayablesPage = lazyRouteComponent(() => import('src/pages/ViewPayablesPage/ViewPayablesPage'));
export const ReceivingTicketsPage = lazyRouteComponent(
  () => import('src/pages/ReceivingTicketsPage/ReceivingTicketsPage')
);
export const BusinessEntityPage = lazyRouteComponent(() => import('src/pages/BusinessEntityPage/BusinessEntityPage'));
export const PickTicketPage = lazyRouteComponent(() => import('src/pages/PickTicketPage/PickTicketPage'));
export const PickTicketsPage = lazyRouteComponent(() => import('src/pages/PickTicketsPage/PickTicketsPage'));
export const ProductionRunPage = lazyRouteComponent(() => import('src/pages/ProductionRunPage/ProductionRunPage'));
export const ProductionRunsPage = lazyRouteComponent(() => import('src/pages/ProductionRunsPage/ProductionRunsPage'));
export const PurchaseOrderPage = lazyRouteComponent(() => import('src/pages/PurchaseOrderPage/PurchaseOrderPage'));
export const PurchaseOrdersPage = lazyRouteComponent(() => import('src/pages/PurchaseOrdersPage/PurchaseOrdersPage'));
export const SalesOrderPage = lazyRouteComponent(() => import('src/pages/SalesOrderPage/SalesOrderPage'));
export const SalesOrdersPage = lazyRouteComponent(() => import('src/pages/SalesOrdersPage/SalesOrdersPage'));
